import { Flex, Text } from '@chakra-ui/react';

interface PlaceholderTabProps {
  tabName: string;
}

export function PlaceholderTab({ tabName }: PlaceholderTabProps) {
  return (
    <Flex
      flex="1"
      align="center"
      justify="center"
      data-testid={`placeholder-tab-${tabName.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <Text fontSize="13px" color="gray.400">
        {tabName} results will appear here
      </Text>
    </Flex>
  );
}
